module.exports = __webpack_public_path__ + "static/img/dncbanner.2816f71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dncbanner.jpg
// module id = CAb2
// module chunks = 1